import { statusLote } from '../types'

export function formatStatusFilter(values: string[]) {
  const statusFilter = values.includes('TODOS')
    ? statusLote.map(status => status.value)
    : values

  return statusFilter
}
